/**
 * Minimal browser shim (from node-process) so dependencies can read `process`.
 * NODE_ENV is inlined at build time where available.
 */
const processShim = {
  env: {
    NODE_ENV: process.env.NODE_ENV || "development",
  },
  browser: true,
  version: "",
  versions: {},
  argv: [],
  title: "browser",
  nextTick(fn) {
    setTimeout(fn, 0);
  },
  on() {},
  addListener() {},
  once() {},
  off() {},
  removeListener() {},
  removeAllListeners() {},
  emit() {},
  listeners() {
    return [];
  },
  binding() {
    throw new Error("process.binding is not supported");
  },
  cwd() {
    return "/";
  },
  chdir() {
    throw new Error("process.chdir is not supported");
  },
  umask() {
    return 0;
  },
};

export default processShim;
